import { api } from "@/lib/api";

const EXT_TYPES = {
  jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp", heic: "image/heic", heif: "image/heif",
  mp4: "video/mp4", mov: "video/quicktime", webm: "video/webm",
};

export const CHUNK_SIZE = 2 * 1024 * 1024;
export const ACCEPT_MEDIA = "image/jpeg,image/png,image/webp,image/heic,image/heif,video/mp4,video/quicktime,video/webm,.jpg,.jpeg,.png,.webp,.heic,.mp4,.mov,.webm";
export const ACCEPT_IMAGES = "image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic";

export const fileContentType = (file) => {
  if (file.type) return file.type;
  const ext = file.name.split(".").pop()?.toLowerCase();
  return EXT_TYPES[ext] || "";
};

// Uploads a file in sequential chunks to the admin media endpoint.
export async function uploadMediaChunked(file, onProgress) {
  const uploadId = crypto.randomUUID();
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  const contentType = fileContentType(file);
  let result = null;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK_SIZE, Math.min(file.size, (i + 1) * CHUNK_SIZE));
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    fd.append("total_chunks", String(total));
    fd.append("filename", file.name);
    fd.append("content_type", contentType);
    fd.append("total_size", String(file.size));
    fd.append("chunk", blob, "chunk");
    const { data } = await api.post("/admin/media/chunk", fd, {
      onUploadProgress: (e) => {
        const frac = (i + (e.total ? e.loaded / e.total : 1)) / total;
        onProgress?.(Math.min(99, Math.round(frac * 100)));
      },
    });
    result = data;
  }
  onProgress?.(100);
  return result;
}
